import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/arrow.png'
import _imports_1 from '../../assets/bus-icon.png'


const _hoisted_1 = { class: "body-section other-city" }
const _hoisted_2 = { class: "city-list__container" }
const _hoisted_3 = { class: "article-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "找公車", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "decoration-line" }, null, -1)
const _hoisted_6 = { class: "article-content" }
const _hoisted_7 = { class: "city-list" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "bus-icon"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderBar = _resolveComponent("HeaderBar")!
  const _component_BaseLayout = _resolveComponent("BaseLayout")!

  return (_openBlock(), _createBlock(_component_BaseLayout, null, {
    header: _withCtx(() => [
      _createVNode(_component_HeaderBar)
    ]),
    body: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("article", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "back",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
            }),
            _hoisted_4,
            _hoisted_5
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherCities, (city) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: city.value,
                  class: "city-list__button",
                  onClick: ($event: any) => (_ctx.selectCity(city.value))
                }, [
                  _hoisted_9,
                  _createElementVNode("h4", null, _toDisplayString(city.name), 1)
                ], 8, _hoisted_8))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}